import * as React from "react";
import { formatPhoneNumber } from "./phoneUtils";
import { ContactActions } from "./ContactActions";
import { UpdateContactModal } from "./UpdateContactModal";

export function ContactCard({ contact, hasChat, sectionType, onSuccess, disablePopup }) {
  const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);

  if (!contact) return null;

  const { email, phones } = contact;

  const firstName = contact.FirstName || '';
  const lastName = contact.LastName || '';
  const displayName = `${firstName} ${lastName}`.trim();

  const handleCardClick = (e) => {
    if (disablePopup) return;
    // Prevent opening modal if clicking on action buttons or links
    if (e.target.closest('.contact-actions') || e.target.closest('a')) {
      return;
    }
    setIsEditModalOpen(true);
  };

  const hasAddress = contact.MailingStreet || contact.MailingCity || contact.MailingState || contact.MailingPostalCode;

  const missingStyle = { color: '#b0b0b0', fontStyle: 'italic' };

  // Check if this is a vendor card - vendors should not be full width on desktop
  const isVendorCard = sectionType === "Vendors";
  
  return (
    <>
      <div
        className={`contact-card p-1 max-w-full ${isVendorCard ? 'w-auto' : 'w-full'} max-md:w-full overflow-hidden ${disablePopup ? '' : 'cursor-pointer'}`}
        onClick={handleCardClick}
      >
        <div className={`contact-card-inner max-w-full ${isVendorCard ? 'w-auto' : 'w-full'} max-md:w-full`}>
          <div className="contact-card-top flex justify-between items-start gap-2 max-w-full w-full">
            <div className="contact-card-identity flex-1 min-w-0 max-w-full overflow-hidden">
              <h2 
                className="contact-card-name text-xl max-md:text-base text-gray-800 font-semibold mb-0.5 break-words" 
                title={displayName}
                style={{ fontWeight: 600, wordBreak: 'break-word', overflowWrap: 'break-word' }}
              >
                {displayName}
              </h2>
              <div className="contact-card-meta">
                <div
                  className="contact-card-account text-gray-700 text-base max-md:text-sm break-words"
                  style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}
                  title={contact.AccountName}
                >
                  {contact.AccountName ? contact.AccountName : <span style={missingStyle}>-</span>}
                </div>
                <div
                  className="contact-card-job-title text-gray-700 text-base max-md:text-sm break-words"
                  style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}
                  title={contact.Title}
                >
                  {contact.Title ? contact.Title : <span style={missingStyle}>no title</span>}
                </div>
              </div>
            </div>
            <div className="contact-actions flex-shrink-0">
              <ContactActions 
                contact={contact}
                hasChat={hasChat}
                onSuccess={onSuccess}
                disableActions={disablePopup}
              />
            </div>
          </div>
        </div>

        <div className={`contact-card-details space-y-1 max-w-full ${isVendorCard ? 'w-auto' : 'w-full'} max-md:w-full overflow-hidden mt-1`}>
          <div className="contact-card-phones">
            <div className="contact-card-phone contact-card-phone--work break-words text-sm max-md:text-xs" style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
              {phones[0] ? (
                <>
                  <span className="contact-card-phone-number" style={{ color: '#c00' }}>{formatPhoneNumber(phones[0])}</span>
                  <span className="contact-card-phone-label" style={{ marginLeft: 6 }}>Work</span>
                </>
              ) : (
                <span style={missingStyle}>no work</span>
              )}
            </div>
            <div className="contact-card-phone contact-card-phone--mobile break-words text-sm max-md:text-xs" style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
              {phones[1] ? (
                <>
                  <span className="contact-card-phone-number" style={{ color: '#c00' }}>{formatPhoneNumber(phones[1])}</span>
                  <span className="contact-card-phone-label" style={{ marginLeft: 6 }}>Mobile</span>
                </>
              ) : (
                <span style={missingStyle}>no mobile</span>
              )}
            </div>
          </div>
          <div className="contact-card-email break-words text-sm max-md:text-xs" style={{ color: '#c00', wordBreak: 'break-word', overflowWrap: 'break-word' }} title={email}>
            {email ? email : <span style={missingStyle}>-</span>}
          </div>
          {hasAddress ? (
            <div className="contact-card-address">
              <div className="contact-card-address-street break-words text-sm max-md:text-xs" style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }} title={contact.MailingStreet}>
                {contact.MailingStreet ? contact.MailingStreet : <span style={missingStyle}>-</span>}
              </div>
              <div className="contact-card-address-city break-words text-sm max-md:text-xs" style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }} title={`${contact.MailingCity}, ${contact.MailingState} ${contact.MailingPostalCode}`}>
                {(contact.MailingCity ? contact.MailingCity : <span style={missingStyle}>-</span>)}
                {', '}
                {(contact.MailingState ? contact.MailingState : <span style={missingStyle}>-</span>)}
                {' '}
                {(contact.MailingPostalCode ? contact.MailingPostalCode : <span style={missingStyle}>-</span>)}
              </div>
            </div>
          ) : (
            <div className="contact-card-address break-words text-sm max-md:text-xs" style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
              <span style={missingStyle}>no address</span>
            </div>
          )}
        </div>
      </div>

      {!disablePopup && (
        <UpdateContactModal
          isOpen={isEditModalOpen}
          onClose={() => setIsEditModalOpen(false)}
          contact={contact}
        />
      )}
    </>
  );
}
